import {emotionStyled} from '@packages/utilities/styled';

import {Text} from '../Text';
import {Stack} from '../Stack';

export const FormGroupView = emotionStyled(Stack)(
  {},
  {
    componentName: 'FormGroup',
    variants: {
      size: {
        medium: {
          gap: '$1',
        },
        'x-large': {
          gap: '$2',
        },
      },
    },
  }
);

export const FormHelperTextView = emotionStyled(Text)(
  {},
  {
    componentName: 'FormHelperText',
  }
);

export const FormFeedbackTextView = emotionStyled(Text)(
  {},
  {
    componentName: 'FormFeedbackText',
  }
);
